// extracted by mini-css-extract-plugin
export default {"lockdown":"RestDayLockdown_lockdown__4EViG","title":"RestDayLockdown_title__3hh++","subtitle":"RestDayLockdown_subtitle__oFN+1"};